import axios, { AxiosResponse } from "axios";
import { LoginData } from "../store/slices/auth";
import { AuthData, AuthResponse, ChangePasswordRequest, CorporationByModule, CorporationUserByModule, S10GenericResponse } from "../interfaces/auth.interface";
import { store } from "../store";


const authApi = axios.create({
    baseURL: process.env.REACT_APP_AUTH_API,
});

const s10Api = axios.create({
    baseURL: process.env.REACT_APP_S10_API,
	headers: {
		moduleId: process.env.REACT_APP_MODULE_ID,
		AccessTypeId: process.env.REACT_APP_AUTH_TYPE,
	}
});


export const loginRequest = async (loginData: LoginData) => {
	const resp: AxiosResponse<AuthResponse> = await authApi.post('/LogonApp', {
		ModuleId: process.env.REACT_APP_MODULE_ID,
		AccessTypeId: process.env.REACT_APP_AUTH_TYPE,
		RoleAlternative: true,
		...loginData,
	});
	return resp;
}

export const recoverPasswordRequest = async (userEmail: string) => {
	const resp: AxiosResponse<AuthResponse> = await authApi.post('/SendNewPassword', {
		ModuleId: process.env.REACT_APP_MODULE_ID,
		AccessTypeId: process.env.REACT_APP_AUTH_TYPE,
		Email: userEmail,
	});
	return resp;
}

export const changePasswordRequest = async (props: ChangePasswordRequest): Promise<AuthResponse | null> => {
	const authCompanySelectedState = store.getState().auth;
	const data =  {
		AccessTypeId: process.env.REACT_APP_AUTH_TYPE,
		UserId: authCompanySelectedState?.sessionData?.UserId,
		...props,
	};
	const headers = {
		ModuleId: process.env.REACT_APP_MODULE_ID,
		Token: authCompanySelectedState.companyselected?.Token,

	}
	const resp: AuthResponse | null = await authApi
					.post('/ChangeUserPassword',data , {headers})
					.then( r => r.data as AuthResponse)
					.catch(e => {
						console.error(e);
						return null;
					});
	return resp;
}

export const get10CorporationsByModule = async (): Promise<CorporationByModule[] | null> => {
	const resp = await s10Api.get(
		`/SecurityCorporationApi/FindCorporationsByModule?moduleId=${process.env.REACT_APP_MODULE_ID}`,
	)
		.then( r => r.data as CorporationByModule[])
		.catch(e => {
			console.error(e);
			return null;
		});
	return resp;
}

export const get10CorporationsUsersByModule = async (scmId: CorporationByModule['SecurityCorporationModuleId']): Promise<CorporationUserByModule[] | null> => {
	const resp = await s10Api.get(
		`/SecurityUserApi/UsersByCorporationModuleToList?corporationModuleId=${scmId}`,
	)
		.then( r => r.data as CorporationUserByModule[])
		.catch(e => {
			console.error(e);
			return null;
		});
	return resp;
}

export const getToken10CorporationsUsersByModule = async (
	token: string, 
	userName: CorporationUserByModule['UserName'],
	password: CorporationUserByModule['Password'],
): Promise<S10GenericResponse<AuthData> | null> => {
	
	const body = {
		SupportToken: token,
		ModuleId: process.env.REACT_APP_MODULE_ID,
		UserName: userName,
		Password: password,
		RoleAlternative: true,
	}
	const resp = await s10Api.post(
		`/SecurityAuthApi/GenerateSupportAccessTokenApp`,
		body,
	)
		.then( r => r.data as S10GenericResponse<AuthData>)
		.catch(e => {
			console.error(e);
			return null;
		});
	return resp;
}